import JSLogger from '@ytica/js-logger'

const logger = new JSLogger({
  name: 'App',
  level: JSLogger.ERROR
})

export default logger



// WEBPACK FOOTER //
// ./src/logger.js